// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outer-container {
  position: absolute;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4); /* 40% opacity black */
  z-index: 997;
}

.inner-container {
  position: fixed;
  bottom: 0vh;
  width: 85%;
  height: 100%;
  background-color: var(--neutral-white);
  z-index: 998;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  /* Other styles for the inner container go here */
}

.userDiv {
  border-bottom: 3px solid var(--light-neutral-2);
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}

.bottomSectionDiv {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.lngBtnDiv {
  display: flex;
  border-radius: 8px;
  border: 1px solid;
  border-color: rgba(67, 77, 207, 0.3);
  align-items: center;
  padding: 1px;
  margin-bottom: 22px;
  width: 69%;
}

.selectedLngBtn {
  background: var(--primary-dark);
  color: var(--neutral-white);
}

.normalBtn {
  color: var(--primary-dark);
  opacity: 80%;
}

.changeSizeBtnDiv {
  border: 1px solid var(--light-neutral-3);
  border-radius: 8px;
  width: 44%;
  height: 40px;
  margin-bottom: 20px;
  margin-top: 8px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/Core/Components/SideMenu/SideMenu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,sBAAsB;EAC5D,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,YAAY;EACZ,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB","sourcesContent":[".outer-container {\n  position: absolute;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4); /* 40% opacity black */\n  z-index: 997;\n}\n\n.inner-container {\n  position: fixed;\n  bottom: 0vh;\n  width: 85%;\n  height: 100%;\n  background-color: var(--neutral-white);\n  z-index: 998;\n  display: flex;\n  flex-direction: column;\n  overflow-y: scroll;\n  /* Other styles for the inner container go here */\n}\n\n.userDiv {\n  border-bottom: 3px solid var(--light-neutral-2);\n  display: flex;\n  flex-direction: column;\n  row-gap: 16px;\n}\n\n.bottomSectionDiv {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n.lngBtnDiv {\n  display: flex;\n  border-radius: 8px;\n  border: 1px solid;\n  border-color: rgba(67, 77, 207, 0.3);\n  align-items: center;\n  padding: 1px;\n  margin-bottom: 22px;\n  width: 69%;\n}\n\n.selectedLngBtn {\n  background: var(--primary-dark);\n  color: var(--neutral-white);\n}\n\n.normalBtn {\n  color: var(--primary-dark);\n  opacity: 80%;\n}\n\n.changeSizeBtnDiv {\n  border: 1px solid var(--light-neutral-3);\n  border-radius: 8px;\n  width: 44%;\n  height: 40px;\n  margin-bottom: 20px;\n  margin-top: 8px;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
